import { z } from 'zod';
import { z as zV4 } from 'zod/v4';
// Letters + spaces only. Hyphens are transformed away before validation.
// Apostrophes, accents, digits, and all other punctuation are rejected —
// GDS / airlines cannot process them in passenger names.
export const NAME_REGEX = /^[a-zA-Z ]+$/;
export const NAME_TOOLTIP_TEXT = 'Les accents et la ponctuation (tiret, apostrophe, etc.) ne sont pas autorisés. Les tirets seront automatiquement remplacés par des espaces.';
export const NAME_ERROR = 'Ce champ ne doit contenir que des lettres sans accent ni ponctuation (apostrophes et caractères spéciaux interdits).';
/** Replaces hyphens with spaces, collapses whitespace, trims. */
export const sanitizeNameInput = (value) => value.replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
// ---- Zod v3 (used by packages/features, apps/backoffice) ----
export const createNameSchema = (fieldLabel) => z
    .string()
    .min(1, `${fieldLabel} requis`)
    .transform(sanitizeNameInput)
    .pipe(z.string().min(1, `${fieldLabel} requis`).regex(NAME_REGEX, NAME_ERROR));
export const firstNameSchema = createNameSchema('Prénom');
export const lastNameSchema = createNameSchema('Nom');
// ---- Zod v4 (used by apps/web) ----
export const createNameSchemaV4 = (fieldLabel) => zV4
    .string()
    .min(1, `${fieldLabel} requis`)
    .transform(sanitizeNameInput)
    .pipe(zV4.string().min(1, `${fieldLabel} requis`).regex(NAME_REGEX, NAME_ERROR));
export const firstNameSchemaV4 = createNameSchemaV4('Prénom');
export const lastNameSchemaV4 = createNameSchemaV4('Nom');
